<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <template v-if="cashBoxConfig">
      <v-container
        id="data-tables"
      >
        <ik-data-table
          :model="model"
          :use-delete-action="false"
          :use-edit-action="false"
          entity-name="SettlementList"
          icon="mdi-cash-usd"
        >
          <template
            #item.rePrint="{item}"
          >
            <v-btn
              :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
              :icon="!$vuetify.breakpoint.lgAndUp"
              :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
              :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
              color="amber lighten-4 black--text"
              elevation="0"
              small
              @click.stop="rePrint(item)"
            >
              <template v-if="!$vuetify.breakpoint.lgAndUp">
                <v-icon color="white">
                  mdi-cloud-print
                </v-icon>
              </template>
              <template v-if="$vuetify.breakpoint.lgAndUp">
                <div
                  :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
                  :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
                >
                  {{ $t('reprint') }}
                </div>
              </template>
            </v-btn>
          </template>
        </ik-data-table>
      </v-container>
    </template>
    <template v-else>
      <div
        class="d-flex justify-center align-center flex-column"
        style="height: 65vh"
      >
        <h1 class="text-h2 font-weight-black">
          404
        </h1>

        <div class="text-h4 mt-4">
          {{ $t('functionNotOpen') }} :(
        </div>
        <div class="mb-5 text-body-1">
          {{ $t('openSettingOrCallUs') }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import SettlementList, { reprintSettlement } from '@/model/dataLayer/api/SettlementList'
import { forceGetSystemSetting } from '@/model/dataLayer/api/NewSettings'
import { showSuccessMessage } from '@/model/utils/utils'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      cashBoxConfig: false,
      model: SettlementList
    })
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {
      const res = await forceGetSystemSetting({
        section: 'CashBox',
        sKey: 'enabled',
        sValue: '0',
        defaultValue: '0',
        sType: 'boolean',
        minimumVersion: '1.7.825',
        sOptions: '',
        tagList: 'basic,cash,box'
      })
      if (res === '1') {
        this.cashBoxConfig = true
      }
    },
    async rePrint (item) {
      await reprintSettlement(item.id)
      showSuccessMessage('打印成功')
    }
  }
}
</script>
